import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock-circle-fill",
  "use": "icon-lock-circle-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock-circle-fill\">\n<rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#F2F3F5\" />\n<rect x=\"8.7\" y=\"6.7\" width=\"6.6\" height=\"4.6\" rx=\"2.3\" stroke=\"#86909C\" stroke-width=\"1.4\" />\n<rect x=\"7\" y=\"11\" width=\"10\" height=\"7\" rx=\"1.5\" fill=\"#86909C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/lock-circle-fill.svg
// module id = fE+U
// module chunks = 258